import { inject, signal } from '@angular/core';
import { StationsService } from '../../../services';
import { PublicRoutes } from '../../../enums';
import { Router } from '@angular/router';
import { Station, StationGroup } from '../../../models';

/** when extending this class be sure to implement ngOnInit,
 * @Input() set skipDurationSelect(skip: boolean) {
 *  this.stationsService.skipDurationSelect = skip;
 * }
 * 
 * @Input() set addButtonForAllDay(add: boolean) {
 *  this.stationsService.addButtonForAllDay = add;
 * }
 * 
 * @Input() set stationHasTerms(hasTerms: boolean) {
 *  this.stationsService.stationHasTerms = hasTerms;
 * }
 * 
 * @Input() set showAddOns(showAddOns: boolean) {
 *  this.stationsService.showAddOns = showAddOns;
 * }
*/
export class NgxAimViewGroup {
  // ngOnInit() {
  //   this.init();
  // }

  // @Input() set skipDurationSelect(skip: boolean) {
  //   this.stationsService.skipDurationSelect = skip;
  // }

  // @Input() set addButtonForAllDay(add: boolean) {
  //   this.stationsService.addButtonForAllDay = add;
  // }

  // @Input() set stationHasTerms(hasTerms: boolean) {
  //   this.stationsService.stationHasTerms = hasTerms;
  // }

  // @Input() set showAddOns(showAddOns: boolean) {
  //   this.stationsService.showAddOns = showAddOns;
  // }

  stationsService = inject(StationsService);
  router = inject(Router);

  stations: Station[] = [];
  isLoading = signal(true);
  routes = PublicRoutes;
  selectedGroup: StationGroup | null = this.stationsService.getSelectedGroup();

  init() {
    if (!this.selectedGroup) {
      this.router.navigate([this.routes.STATIONS, this.routes.GROUPS]);
    }
  }
}